module.exports = __webpack_public_path__ + "static/media/9.cffb0f4a.png";